export default {"src":"/_next/static/media/SpinalDisorders.f64251fc.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};